<template>
  <div id="dropdown-card" ref="dropdown-card">
    <div class="header-section" @click="toggleDropdown">
      <div class="header">
        <slot name="header"></slot>
      </div>
      <div class="icon">
        <img
          src="/static/icons/toggle-icon.svg"
          ref="icon"
          @click.stop="toggleDropdown"
        />
      </div>
    </div>
    <div class="content-section" ref="content-section">
      <transition name="zoom">
        <slot></slot>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "DropdownCard",
  props: {
    isOpen: {
      type: Boolean,
      required: false,
      default: true
    },
    title: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    },
    height: {
      type: String,
      required: false,
      default: "fit-content"
    },
    width: {
      type: String,
      required: false,
      default: "100%"
    }
  },
  data() {
    return {
      showContentPart: true,
      isOpening: false
    };
  },
  watch: {
    isOpen() {
      this.initDropdown();
    }
  },
  mounted() {
    this.$refs["dropdown-card"].style.width = this.width;
    this.initDropdown();
  },
  methods: {
    initDropdown() {
      this.showContentPart = this.isOpen;
      if (this.showContentPart) {
        this.$refs["content-section"].style["max-height"] = "500px";
        this.$refs["icon"].style.transform = "rotate(180deg)";
        this.$refs["content-section"].style["overflow"] = "unset";
      } else {
        this.$refs["content-section"].style["overflow"] = "hidden";
        this.$refs["content-section"].style["max-height"] = 0 + "px";
      }
    },
    toggleDropdown() {
      if (this.isOpening === false) {
        this.isOpening = true;
        const rotate = this.showContentPart ? 0 : 180;
        const toHeight = this.showContentPart ? 0 : "500px";
        this.showContentPart = !this.showContentPart;
        this.$refs["content-section"].style["max-height"] = toHeight;
        this.$refs["content-section"].style["overflow"] = "hidden";
        this.$anime.timeline().add({
          targets: this.$refs["icon"],
          rotateZ: rotate,
          easing: "easeOutExpo",
          complete: () => {
            this.isOpening = false;
            if (toHeight !== 0) {
              this.$refs["content-section"].style["overflow"] = "unset";
            }
          }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#dropdown-card {
  background: #fff;
  box-shadow: $basic-shadow;
  border-radius: 10px;
  padding: 10px;
  .header-section {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    height: 40px;
    border-bottom: 2px solid $color-light-primary;
    .header {
      margin-left: 10px;
    }
    .icon {
      cursor: pointer;
      margin-right: 10px;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      // background-color: aliceblue;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        height: 100%;
        width: 100%;
      }
      svg {
        fill: $color-primary;
      }
    }
  }
  .content-section {
    overflow: hidden;
    transition: all 0.7s ease-in-out;
    max-height: 500px;
    border-top: 2px solid $color-light-primary;
  }
}
</style>
